import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const NAMES = ['Carla', 'María', 'Lucía', 'Ana', 'Sofía', 'Paula', 'Daniela', 'Valentina', 'Camila', 'Martina', 'Julia', 'Elena'];
const CITIES = ['Buenos Aires', 'Ciudad de México', 'Bogotá', 'Santiago', 'Lima', 'Montevideo', 'Córdoba', 'Medellín', 'Guadalajara', 'Rosario'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      // Schedule next notification (random between 8-15 seconds after hiding)
      const nextDelay = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000) + 5000;
      setTimeout(showNotification, nextDelay);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-fade-in-up max-w-xs w-full" data-id="element-172">
      <div className="bg-white rounded-lg shadow-xl p-4 border-l-4 border-purple-500 flex items-center gap-3" data-id="element-173">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-174">
          <CheckCircle className="w-5 h-5 text-green-600" data-id="element-175" />
        </div>
        <div data-id="element-176">
          <p className="text-sm font-medium text-gray-900" data-id="element-177">
            <span className="font-bold" data-id="element-178">{data.name}</span> de {data.city}
          </p>
          <p className="text-xs text-gray-500" data-id="element-179">
            compró el Mega Pack Terapéutico
          </p>
          <p className="text-xs text-purple-600 font-semibold mt-1" data-id="element-180">
            Hace unos instantes
          </p>
        </div>
      </div>
    </div>;
}